

// 20-5-2026
// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useTheme } from '@mui/material/styles';
// import { Snackbar, Alert } from '@mui/material';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import moment from 'moment';
// import { GetallProjectsdata } from '../../Redux/Actions/Projects_Action';
// import { ProjectTablee } from './ProjectTablee';
// import { useSidebarWidth } from '../../Utility/useSidebarWidth';

// // ─── Icons ───────────────────────────────────────────────────────────────────
// const IconSearch   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
// const IconFilter   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
// const IconCopy     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
// const IconPlus     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
// const IconTrend    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
// const IconBuilding = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>;
// const IconMoney    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;

// // ─── Helpers ─────────────────────────────────────────────────────────────────
// const formatCurrency = (amount) => {
//   if (!amount && amount !== 0) return '—';
//   if (amount >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1)}M`;
//   if (amount >= 1_000)     return `$${(amount / 1_000).toFixed(0)}K`;
//   return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);
// };

// const EXPANDED_WIDTH = 242;

// // ─── Component ───────────────────────────────────────────────────────────────
// export const AllProjects = () => {
//   const dispatch = useDispatch();
//   const theme    = useTheme();
//   const mode     = theme.palette.mode;

//   const [loading,          setLoading]          = useState(true);
//   const [searchTerm,       setSearchTerm]       = useState('');
//   const [developerFilter,  setDeveloperFilter]  = useState('all');
//   const [cityFilter,       setCityFilter]       = useState('all');
//   const [priceFilter,      setPriceFilter]      = useState('all');
//   const [showFilter,       setShowFilter]       = useState(false);
//   const [page,             setPage]             = useState(1);
//   const [itemsPerPage,     setItemsPerPage]     = useState(10);
//   const [copyOpen,         setCopyOpen]         = useState(false);
//   const [userlogin,        setUserlogin]        = useState(null);
//   // const [sidebarWidth,     setSidebarWidth]     = useState(EXPANDED_WIDTH);
//   const [selectedProjects, setSelectedProjects] = useState([]);
//   const sidebarWidth = useSidebarWidth();

//   // ✅ ref على الـ table section عشان نعرف الـ left بالظبط
//   const tableSectionRef = useRef(null);
//   const [paginationLeft, setPaginationLeft] = useState(sidebarWidth);

//   useEffect(() => {
//     const u = localStorage.getItem('user');
//     if (u) setUserlogin(JSON.parse(u));
//   }, []);

//   // ✅ نستمع لتغيير الـ sidebar
//   // useEffect(() => {
//   //   const handler = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
//   //   window.addEventListener('sidebarResized', handler);
//   //   return () => window.removeEventListener('sidebarResized', handler);
//   // }, []);
  

//   // ✅ نحسب left الـ pagination من موضع الـ table section الحقيقي
//   useEffect(() => {
//     const calcLeft = () => {
//       if (tableSectionRef.current) {
//         const rect = tableSectionRef.current.getBoundingClientRect();
//         setPaginationLeft(rect.left);
//       }
//     };
//     calcLeft();
//     window.addEventListener('resize', calcLeft);
//     return () => window.removeEventListener('resize', calcLeft);
//   }, [sidebarWidth]);

//   const run = async () => {
//     setLoading(true);
//     await dispatch(GetallProjectsdata());
//     setLoading(false);
//   };
//   useEffect(() => { run(); }, []);

//   const resProjects = useSelector((state) => state.AllProjects.Projects);
//   const allprojects = Array.isArray(resProjects?.data) ? resProjects.data : [];

//   const filtered = allprojects.filter((p) => {
//     const q = searchTerm.toLowerCase();
//     const matchSearch = !q ||
//       p.name?.toLowerCase().includes(q) ||
//       p.developer?.name?.toLowerCase().includes(q) ||
//       p.area?.toLowerCase().includes(q) ||
//       p.city?.name?.toLowerCase().includes(q);
//     const matchDev  = developerFilter === 'all' || p.developer?.name === developerFilter;
//     const matchCity = cityFilter === 'all' || p.city?.name === cityFilter;
//     let matchPrice = true;
//     if (priceFilter !== 'all') {
//       const price = p.startprice || 0;
//       if (priceFilter === '0-100k')    matchPrice = price <= 100000;
//       if (priceFilter === '100k-500k') matchPrice = price > 100000 && price <= 500000;
//       if (priceFilter === '500k-1M')   matchPrice = price > 500000 && price <= 1000000;
//       if (priceFilter === '1M+')       matchPrice = price > 1000000;
//     }
//     return matchSearch && matchDev && matchCity && matchPrice;
//   });

//   const totalPages = Math.ceil(filtered.length / itemsPerPage);
//   const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

//   const uniqueDevelopers = [...new Set(allprojects.map((p) => p.developer?.name).filter(Boolean))];
//   const uniqueCities     = [...new Set(allprojects.map((p) => p.city?.name).filter(Boolean))];
//   const totalValue       = allprojects.reduce((s, p) => s + (p.startprice || 0), 0);
//   const avgPrice         = allprojects.length ? Math.round(totalValue / allprojects.length) : 0;

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setPage(1);
//   };

//   // Checkbox helpers
//   const isAllSelected  = pageItems.length > 0 && pageItems.every(p => selectedProjects.includes(p._id));
//   const isSomeSelected = selectedProjects.length > 0 && !isAllSelected;

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       setSelectedProjects(pageItems.map(p => p._id));
//     } else {
//       setSelectedProjects([]);
//     }
//   };

//   const handleSelectProject = (id) => {
//     setSelectedProjects(prev =>
//       prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
//     );
//   };

//   // Smart page numbers with ellipsis
//   const buildPageNumbers = () => {
//     if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
//     const pages = [];
//     if (page <= 4) {
//       pages.push(1, 2, 3, 4, 5, '...', totalPages);
//     } else if (page >= totalPages - 3) {
//       pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
//     } else {
//       pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
//     }
//     return pages;
//   };

//   return (
//     <>
//       <div
//         className={`ap-shell ${mode}`}
//         style={{
//           marginLeft: sidebarWidth,
//           transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           marginTop: '50px',
//           // ✅ مساحة في الأسفل عشان الـ pagination الثابت ميغطيش المحتوى
//           paddingBottom: filtered.length > 0 ? '68px' : 0,
//         }}
//       >

//         {/* ─── Breadcrumbs ─── */}
//         <section style={{ padding: '20px 28px 0', marginBottom: '-8px' }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
//             <Link
//  to={
//                   userlogin?.data?.role === 'Admin'
//                     ? '/AllLeadsForAdmin'
//                     : userlogin?.data?.role === 'Marketer'
//                       ? '/LeadsForMarketer'
//                       : userlogin?.data?.role === 'Accountant'
//                         ? '/LeadsForAccountant'
//                         : '/Dashboard'
//                 }              style={{
//                 textDecoration: 'none',
//                 color: mode === 'dark' ? '#9ca3af' : '#6b7280',
//                 fontWeight: 500,
//                 fontFamily: "'DM Sans', sans-serif",
//               }}
//             >
//               Home
//             </Link>
//             <span style={{ color: mode === 'dark' ? '#4b5563' : '#d1d5db' }}>/</span>
//             <span style={{ color: mode === 'dark' ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
//               Projects
//             </span>
//           </div>
//         </section>

//         {/* ─── Stats Cards ─── */}
//         <section className="ap-stats" style={{ padding: '24px 28px 0' }}>
//           <div className="ap-stat-card light">
//             <div>
//               <div className="ap-stat-label">TOTAL PROJECTS</div>
//               <div className="ap-stat-value">{allprojects.length}</div>
//               <div className="ap-stat-badge green">↑ +12.4% PERFORMANCE INCREASE</div>
//             </div>
//             <div className="ap-stat-icon light-icon"><IconBuilding /></div>
//           </div>

//           <div className="ap-stat-card light">
//             <div>
//               <div className="ap-stat-label">PORTFOLIO VALUE</div>
//               <div className="ap-stat-value large">{formatCurrency(totalValue)}</div>
//               {/* <div className="ap-stat-avatars">
//                 <span className="ap-avatar">M</span>
//                 <span className="ap-avatar">J</span>
//                 <span className="ap-avatar">K</span>
//                 <span className="ap-avatar-more">+4 EXECUTIVE MANAGERS</span>
//               </div> */}
//             </div>
//             <div className="ap-stat-icon light-icon"><IconMoney /></div>
//           </div>

//           <div className="ap-stat-card dark-card">
//             <div>
//               <div className="ap-stat-label white">AVG. PROJECT PRICE</div>
//               <div className="ap-stat-value white">{formatCurrency(avgPrice)}</div>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
//                 <span className="ap-badge-pill">PREMIUM RANGE</span>
//                 <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>Top 5% Market Segment</span>
//               </div>
//             </div>
//             <div className="ap-stat-icon dark-icon"><IconTrend /></div>
//           </div>
//         </section>

//         {/* ─── Table Section ─── */}
//         {/* ✅ ref هنا عشان نحسب left الـ pagination */}
//         <section
//           ref={tableSectionRef}
//           className="ap-table-section"
//           style={{ margin: '24px 28px', flex: 1 }}
//         >

//           {/* Bulk bar */}
//           {selectedProjects.length > 0 && (
//             <div className="ap-bulk-bar">
//               <span>{selectedProjects.length} project(s) selected</span>
//             </div>
//           )}

//           {/* Table header */}
//           <div className="ap-table-header">
//             <div>
//               <div className="ap-table-title-label">PROPERTY</div>
//               <div className="ap-table-title">INVENTORY</div>
//             </div>
//             <div className="ap-table-actions">
//               <div className="ap-search-inline">
//                 <IconSearch />
//                 <input
//                   placeholder="Search projects by name, developer, or area..."
//                   value={searchTerm}
//                   onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
//                 />
//               </div>
//               <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
//                 <IconFilter /> Filter
//               </button>
//               <Link to="/Addprojects" style={{ textDecoration: 'none' }}>
//                 <button className="ap-create-btn">
//                   <IconPlus /> Create New Project
//                 </button>
//               </Link>
//             </div>
//           </div>

//           {/* Filter row */}
//           {showFilter && (
//             <div className="ap-filter-row">
//               <select value={developerFilter} onChange={(e) => { setDeveloperFilter(e.target.value); setPage(1); }}>
//                 <option value="all">All Developers</option>
//                 {uniqueDevelopers.map((d) => <option key={d} value={d}>{d}</option>)}
//               </select>
//               <select value={cityFilter} onChange={(e) => { setCityFilter(e.target.value); setPage(1); }}>
//                 <option value="all">All Cities</option>
//                 {uniqueCities.map((c) => <option key={c} value={c}>{c}</option>)}
//               </select>
//               <select value={priceFilter} onChange={(e) => { setPriceFilter(e.target.value); setPage(1); }}>
//                 <option value="all">All Prices</option>
//                 <option value="0-100k">$0 – $100K</option>
//                 <option value="100k-500k">$100K – $500K</option>
//                 <option value="500k-1M">$500K – $1M</option>
//                 <option value="1M+">$1M+</option>
//               </select>
//               <button className="ap-clear-btn" onClick={() => { setDeveloperFilter('all'); setCityFilter('all'); setPriceFilter('all'); setSearchTerm(''); }}>
//                 Clear
//               </button>
//             </div>
//           )}

//           {/* Table */}
//           <div className="ap-table-wrap">
//             <table className="ap-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: 50 }}>
//                     <input
//                       type="checkbox"
//                       className="ap-checkbox"
//                       checked={isAllSelected}
//                       ref={el => { if (el) el.indeterminate = isSomeSelected; }}
//                       onChange={handleSelectAll}
//                     />
//                   </th>
//                   <th>PROJECT NAME</th>
//                   <th>DEVELOPER</th>
//                   <th>CITY</th>
//                   <th>AREA</th>
//                   <th>START PRICE</th>
//                   <th>CREATED DATE</th>
//                   <th>ACTIONS</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={8} className="ap-empty">
//                       <div className="ap-spinner" />
//                       <span>Loading projects...</span>
//                     </td>
//                   </tr>
//                 ) : pageItems.length === 0 ? (
//                   <tr>
//                     <td colSpan={8} className="ap-empty">
//                       <IconSearch />
//                       <p>No projects found</p>
//                     </td>
//                   </tr>
//                 ) : (
//                   pageItems.map((project, i) => (
//                     <tr key={project._id || i} className="ap-row">
//                       <td>
//                         <input
//                           type="checkbox"
//                           className="ap-checkbox"
//                           checked={selectedProjects.includes(project._id)}
//                           onChange={() => handleSelectProject(project._id)}
//                         />
//                       </td>
//                       <td>
//                         <div className="ap-project-cell">
//                           <div className="ap-project-thumb">
//                             {project.name?.slice(0, 2).toUpperCase() || 'PR'}
//                           </div>
//                           <span className="ap-project-name">{project.name || '—'}</span>
//                         </div>
//                       </td>
//                       <td className="ap-cell-muted">{project.developer?.name || '—'}</td>
//                       <td className="ap-cell-muted">{project.city?.name || '—'}</td>
//                       <td className="ap-cell-muted">{project.area || '—'}</td>
//                       <td className="ap-price">
//                         {project.startprice
//                           ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(project.startprice)
//                           : <span style={{ color: '#aaa' }}>—</span>}
//                       </td>
//                       <td className="ap-cell-muted" style={{ fontSize: '13px' }}>
//                         {project.createdAt ? moment(project.createdAt).format('MMM DD, YYYY') : '—'}
//                       </td>
//                       <td>
//                         <div className="ap-actions">
//                           <CopyToClipboard
//                             text={project._id}
//                             onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}
//                           >
//                             <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
//                           </CopyToClipboard>
//                           <ProjectTablee project={project} allprojects={run} iconOnly />
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </section>

//         {/* Footer */}
//         <footer className="ap-footer" style={{ padding: '16px 28px', marginTop: 'auto' }}>
//           <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
//           {/* <div className="ap-footer-links">
//             <span>Privacy Protocol</span>
//             <span>Terms of Engagement</span>
//           </div> */}
//         </footer>
//       </div>

//       {/* ✅ PAGINATION — fixed في الأسفل
//           left = موضع الـ table section الحقيقي (بعد الـ sidebar + margin)
//           right = 0 عشان يمتد لآخر الشاشة زي ما الجدول بيعمل */}
//       {filtered.length > 0 && (
//         <div
//           className={`ap-pagination ${mode === 'dark' ? 'dark' : ''}`}
//           style={{ left: paginationLeft }}
//         >
//           {/* Items per page */}
//           <div className="ap-pagination-info">
//             <span>Items per page:</span>
//             <select
//               className="ap-page-select"
//               value={itemsPerPage}
//               onChange={handleItemsPerPageChange}
//             >
//               <option value={5}>5</option>
//               <option value={10}>10</option>
//               <option value={20}>20</option>
//               <option value={50}>50</option>
//             </select>
//             <span>
//               Showing{' '}
//               <strong>{(page - 1) * itemsPerPage + 1}–{Math.min(page * itemsPerPage, filtered.length)}</strong>
//               {' '}of{' '}
//               <strong>{filtered.length}</strong> projects
//             </span>
//           </div>

//           {/* Page buttons */}
//           <div className="ap-pagination-btns">
//             <button className="ap-pag-btn" onClick={() => setPage(1)} disabled={page === 1}>⟨|</button>
//             <button className="ap-pag-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>‹</button>

//             {buildPageNumbers().map((n, idx) =>
//               n === '...'
//                 ? <span key={`e-${idx}`} className="ap-pag-ellipsis">…</span>
//                 : <button
//                     key={n}
//                     className={`ap-pag-btn ${page === n ? 'active' : ''}`}
//                     onClick={() => setPage(n)}
//                   >{n}</button>
//             )}

//             <button className="ap-pag-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>›</button>
//             <button className="ap-pag-btn" onClick={() => setPage(totalPages)} disabled={page === totalPages}>|⟩</button>
//           </div>
//         </div>
//       )}

//       <Snackbar open={copyOpen} autoHideDuration={2000}>
//         <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
//       </Snackbar>
//     </>
//   );
// };


















import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import { GetallProjectsdata } from '../../Redux/Actions/Projects_Action';
import { ProjectTablee } from './ProjectTablee';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

// ─── Icons ───────────────────────────────────────────────────────────────────
const IconSearch = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const IconFilter = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

const IconCopy = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

const IconPlus = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const IconTrend = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const IconBuilding = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const IconMoney = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

// ─── Helpers ─────────────────────────────────────────────────────────────────
const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '—';
  if (amount >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1)}M`;
  if (amount >= 1_000) return `$${(amount / 1_000).toFixed(0)}K`;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(amount);
};

// ─── Component ───────────────────────────────────────────────────────────────
export const AllProjects = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const mode = theme.palette.mode;

  // ─── State ────────────────────────────────────────────────────────────────
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [developerFilter, setDeveloperFilter] = useState('all');
  const [cityFilter, setCityFilter] = useState('all');
  const [priceFilter, setPriceFilter] = useState('all');
  const [showFilter, setShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [copyOpen, setCopyOpen] = useState(false);
  const [userlogin, setUserlogin] = useState(null);
  const [selectedProjects, setSelectedProjects] = useState([]);

  const sidebarWidth = useSidebarWidth();
  const tableSectionRef = useRef(null);
  const [paginationLeft, setPaginationLeft] = useState(sidebarWidth);

  // ─── Get user from localStorage ──────────────────────────────────────────
  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  // ─── Calculate pagination left position ──────────────────────────────────
  useEffect(() => {
    const calcLeft = () => {
      if (tableSectionRef.current) {
        const rect = tableSectionRef.current.getBoundingClientRect();
        setPaginationLeft(rect.left);
      }
    };
    calcLeft();
    window.addEventListener('resize', calcLeft);
    return () => window.removeEventListener('resize', calcLeft);
  }, [sidebarWidth]);

  // ─── 🔥 Fetch data from API with pagination & filters ──────────────────
  const fetchProjects = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        limit: itemsPerPage,
        page: page,
      };

      // ✅ البحث
      if (searchTerm.trim()) {
        params.search = searchTerm.trim();
      }

      // ✅ المطور
      if (developerFilter !== 'all') {
        params.developer = developerFilter;
      }

      // ✅ المدينة
      if (cityFilter !== 'all') {
        params.city = cityFilter;
      }

      // ✅ السعر
      if (priceFilter !== 'all') {
        switch (priceFilter) {
          case '0-100k':
            params.maxPrice = 100000;
            break;
          case '100k-500k':
            params.minPrice = 100000;
            params.maxPrice = 500000;
            break;
          case '500k-1M':
            params.minPrice = 500000;
            params.maxPrice = 1000000;
            break;
          case '1M+':
            params.minPrice = 1000000;
            break;
          default:
            break;
        }
      }

      await dispatch(GetallProjectsdata(params));
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, itemsPerPage, page, searchTerm, developerFilter, cityFilter, priceFilter]);

  // ─── 🔥 Fetch when any filter changes ──────────────────────────────────
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchProjects();
    }, 500);

    return () => clearTimeout(timer);
  }, [fetchProjects]);

  // ─── Get data from Redux ─────────────────────────────────────────────────
  const resProjects = useSelector((state) => state.AllProjects.Projects);

  const allprojects = Array.isArray(resProjects?.data) ? resProjects.data : [];
  const paginationData = resProjects?.pagination || {};
  const totalItems = paginationData.totalItems || 0;
  const totalPagesFromAPI = paginationData.NumberOfPages || 1;

  // ─── Stats ────────────────────────────────────────────────────────────────
  const totalValue = allprojects.reduce((s, p) => s + (p.startprice || 0), 0);
  const avgPrice = allprojects.length ? Math.round(totalValue / allprojects.length) : 0;

  // ─── Lists for filters (from API data) ───────────────────────────────────
  const uniqueDevelopers = [...new Set(allprojects.map((p) => p.developer?.name).filter(Boolean))];
  const uniqueCities = [...new Set(allprojects.map((p) => p.city?.name).filter(Boolean))];

  // ─── Handlers ─────────────────────────────────────────────────────────────
  const handleItemsPerPageChange = (e) => {
    const newLimit = Number(e.target.value);
    setItemsPerPage(newLimit);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPagesFromAPI) {
      setPage(newPage);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(1);
  };

  const handleDeveloperChange = (e) => {
    setDeveloperFilter(e.target.value);
    setPage(1);
  };

  const handleCityChange = (e) => {
    setCityFilter(e.target.value);
    setPage(1);
  };

  const handlePriceChange = (e) => {
    setPriceFilter(e.target.value);
    setPage(1);
  };

  const handleClearFilters = () => {
    setDeveloperFilter('all');
    setCityFilter('all');
    setPriceFilter('all');
    setSearchTerm('');
    setPage(1);
  };

  // ─── Checkbox helpers ────────────────────────────────────────────────────
  const isAllSelected = allprojects.length > 0 && allprojects.every((p) => selectedProjects.includes(p._id));
  const isSomeSelected = selectedProjects.length > 0 && !isAllSelected;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedProjects(allprojects.map((p) => p._id));
    } else {
      setSelectedProjects([]);
    }
  };

  const handleSelectProject = (id) => {
    setSelectedProjects((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // ─── Smart page numbers with ellipsis ────────────────────────────────────
  const buildPageNumbers = () => {
    const total = totalPagesFromAPI;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', total);
    } else if (page >= total - 3) {
      pages.push(1, '...', total - 4, total - 3, total - 2, total - 1, total);
    } else {
      pages.push(1, '...', page - 1, page, page + 1, '...', total);
    }
    return pages;
  };

  // ─── JSX ──────────────────────────────────────────────────────────────────
  return (
    <>
      <div
        className={`ap-shell ${mode}`}
        style={{
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '50px',
          paddingBottom: totalItems > 0 ? '68px' : 0,
        }}
      >
        {/* ─── Breadcrumbs ─── */}
        <section style={{ padding: '20px 28px 0', marginBottom: '-8px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
            }}
          >
            <Link
              to={
                userlogin?.data?.role === 'Admin'
                  ? '/AllLeadsForAdmin'
                  : userlogin?.data?.role === 'Marketer'
                  ? '/LeadsForMarketer'
                  : userlogin?.data?.role === 'Accountant'
                  ? '/LeadsForAccountant'
                  : '/Dashboard'
              }
              style={{
                textDecoration: 'none',
                color: mode === 'dark' ? '#9ca3af' : '#6b7280',
                fontWeight: 500,
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              Home
            </Link>
            <span style={{ color: mode === 'dark' ? '#4b5563' : '#d1d5db' }}>/</span>
            <span
              style={{
                color: mode === 'dark' ? '#e5e7eb' : '#111827',
                fontWeight: 600,
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              Projects
            </span>
          </div>
        </section>

        {/* ─── Stats Cards ─── */}
        <section className="ap-stats" style={{ padding: '24px 28px 0' }}>
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">TOTAL PROJECTS</div>
              <div className="ap-stat-value">{totalItems}</div>
              <div className="ap-stat-badge green">↑ +12.4% PERFORMANCE INCREASE</div>
            </div>
            <div className="ap-stat-icon light-icon">
              <IconBuilding />
            </div>
          </div>

          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">PORTFOLIO VALUE</div>
              <div className="ap-stat-value large">{formatCurrency(totalValue)}</div>
            </div>
            <div className="ap-stat-icon light-icon">
              <IconMoney />
            </div>
          </div>

          <div className="ap-stat-card dark-card">
            <div>
              <div className="ap-stat-label white">AVG. PROJECT PRICE</div>
              <div className="ap-stat-value white">{formatCurrency(avgPrice)}</div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginTop: '12px',
                }}
              >
                <span className="ap-badge-pill">PREMIUM RANGE</span>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>
                  Top 5% Market Segment
                </span>
              </div>
            </div>
            <div className="ap-stat-icon dark-icon">
              <IconTrend />
            </div>
          </div>
        </section>

        {/* ─── Table Section ─── */}
        <section
          ref={tableSectionRef}
          className="ap-table-section"
          style={{ margin: '24px 28px', flex: 1 }}
        >
          {/* Bulk bar */}
          {selectedProjects.length > 0 && (
            <div className="ap-bulk-bar">
              <span>{selectedProjects.length} project(s) selected</span>
            </div>
          )}

          {/* Table header */}
          <div className="ap-table-header">
            <div>
              <div className="ap-table-title-label">PROPERTY</div>
              <div className="ap-table-title">INVENTORY</div>
            </div>
            <div className="ap-table-actions">
              <div className="ap-search-inline">
                <IconSearch />
                <input
                  placeholder="Search projects by name, developer, or area..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
              <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                <IconFilter /> Filter
              </button>
              <Link to="/Addprojects" style={{ textDecoration: 'none' }}>
                <button className="ap-create-btn">
                  <IconPlus /> Create New Project
                </button>
              </Link>
            </div>
          </div>

          {/* Filter row */}
          {showFilter && (
            <div className="ap-filter-row">
              <select value={developerFilter} onChange={handleDeveloperChange}>
                <option value="all">All Developers</option>
                {uniqueDevelopers.map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </select>
              <select value={cityFilter} onChange={handleCityChange}>
                <option value="all">All Cities</option>
                {uniqueCities.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              <select value={priceFilter} onChange={handlePriceChange}>
                <option value="all">All Prices</option>
                <option value="0-100k">$0 – $100K</option>
                <option value="100k-500k">$100K – $500K</option>
                <option value="500k-1M">$500K – $1M</option>
                <option value="1M+">$1M+</option>
              </select>
              <button className="ap-clear-btn" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
          )}

          {/* Table */}
          <div className="ap-table-wrap">
            <table className="ap-table">
              <thead>
                <tr>
                  <th style={{ width: 50 }}>
                    <input
                      type="checkbox"
                      className="ap-checkbox"
                      checked={isAllSelected}
                      ref={(el) => {
                        if (el) el.indeterminate = isSomeSelected;
                      }}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>PROJECT NAME</th>
                  <th>DEVELOPER</th>
                  <th>CITY</th>
                  <th>AREA</th>
                  <th>START PRICE</th>
                  <th>CREATED DATE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8} className="ap-empty">
                      <div className="ap-spinner" />
                      <span>Loading projects...</span>
                    </td>
                  </tr>
                ) : allprojects.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="ap-empty">
                      <IconSearch />
                      <p>No projects found</p>
                    </td>
                  </tr>
                ) : (
                  allprojects.map((project, i) => (
                    <tr key={project._id || i} className="ap-row">
                      <td>
                        <input
                          type="checkbox"
                          className="ap-checkbox"
                          checked={selectedProjects.includes(project._id)}
                          onChange={() => handleSelectProject(project._id)}
                        />
                      </td>
                      <td>
                        <div className="ap-project-cell">
                          <div className="ap-project-thumb">
                            {project.name?.slice(0, 2).toUpperCase() || 'PR'}
                          </div>
                          <span className="ap-project-name">{project.name || '—'}</span>
                        </div>
                      </td>
                      <td className="ap-cell-muted">{project.developer?.name || '—'}</td>
                      <td className="ap-cell-muted">{project.city?.name || '—'}</td>
                      <td className="ap-cell-muted">{project.area || '—'}</td>
                      <td className="ap-price">
                        {project.startprice ? (
                          new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 0,
                          }).format(project.startprice)
                        ) : (
                          <span style={{ color: '#aaa' }}>—</span>
                        )}
                      </td>
                      <td className="ap-cell-muted" style={{ fontSize: '13px' }}>
                        {project.createdAt ? moment(project.createdAt).format('MMM DD, YYYY') : '—'}
                      </td>
                      <td>
                        <div className="ap-actions">
                          <CopyToClipboard
                            text={project._id}
                            onCopy={() => {
                              setCopyOpen(true);
                              setTimeout(() => setCopyOpen(false), 2000);
                            }}
                          >
                            <button className="ap-action-btn" title="Copy ID">
                              <IconCopy />
                            </button>
                          </CopyToClipboard>
                          <ProjectTablee project={project} allprojects={fetchProjects} iconOnly />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>

        {/* Footer */}
        <footer className="ap-footer" style={{ padding: '16px 28px', marginTop: 'auto' }}>
          <span>
            © 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.
          </span>
        </footer>
      </div>

      {/* ─── ✅ PAGINATION — Fixed at bottom ─────────────────────────────── */}
      {totalItems > 0 && (
        <div
          className={`ap-pagination ${mode === 'dark' ? 'dark' : ''}`}
          style={{ left: paginationLeft }}
        >
          <div className="ap-pagination-info">
            <span>Items per page:</span>
            <select className="ap-page-select" value={itemsPerPage} onChange={handleItemsPerPageChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
            <span>
              Showing{' '}
              <strong>
                {(page - 1) * itemsPerPage + 1}–{Math.min(page * itemsPerPage, totalItems)}
              </strong>{' '}
              of <strong>{totalItems}</strong> projects
            </span>
          </div>

          <div className="ap-pagination-btns">
            <button
              className="ap-pag-btn"
              onClick={() => handlePageChange(1)}
              disabled={page === 1}
            >
              ⟨|
            </button>
            <button
              className="ap-pag-btn"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              ‹
            </button>

            {buildPageNumbers().map((n, idx) =>
              n === '...' ? (
                <span key={`e-${idx}`} className="ap-pag-ellipsis">
                  …
                </span>
              ) : (
                <button
                  key={n}
                  className={`ap-pag-btn ${page === n ? 'active' : ''}`}
                  onClick={() => handlePageChange(n)}
                >
                  {n}
                </button>
              )
            )}

            <button
              className="ap-pag-btn"
              onClick={() => handlePageChange(page + 1)}
              disabled={page === totalPagesFromAPI}
            >
              ›
            </button>
            <button
              className="ap-pag-btn"
              onClick={() => handlePageChange(totalPagesFromAPI)}
              disabled={page === totalPagesFromAPI}
            >
              |⟩
            </button>
          </div>
        </div>
      )}

      <Snackbar open={copyOpen} autoHideDuration={2000}>
        <Alert severity="success" sx={{ width: '100%' }}>
          Copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};